export const iconFontAwesomeMapsWineGlass = (
	<i className="fa-solid fa-wine-glass"></i>
);
